module.exports = __webpack_public_path__ + "static/img/success1.c6fd8430.png";